module.exports = __webpack_public_path__ + "img/9788993225860.61e48420.jpg";